// extracted by mini-css-extract-plugin
export default {"root":"Users_root__XVJl1","actionBtnSmall":"Users_actionBtnSmall__xW5x4"};